<template>
    <div>
       <HeaderTeam header="รายงานและการสรุปยอด" :img_header="header_image" link_back="team"/>
       <MenuTeamReportAndSummaryList/>
       <ReportWorkList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/dashboard.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamReportAndSummaryList from '@/components/menuadmin/team/teamreportandsummary/MenuTeamReportAndSummaryList.vue'
import ReportWorkList from '@/components/menuadmin/team/teamreportandsummary/ReportWorkList.vue'
export default {
    name:'reportWork',
    components:{
        HeaderTeam,
        MenuTeamReportAndSummaryList,
        ReportWorkList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>